import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e1eeeb9e"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 1,
  class: "spinner_box"
}
const _hoisted_2 = {
  key: 2,
  class: "no_data"
}
const _hoisted_3 = { class: "no_data_text1" }
const _hoisted_4 = { class: "no_data_text2" }
const _hoisted_5 = {
  key: 4,
  class: "no_data"
}

import http from '@/js/utils/http'
import API from '@/js/const/api'
import APP from '@/js/const/app'
import Spinner from '@/components/atoms/Spinner'
import { getAddTime, getDateObject, getIsoDateStr } from '@/js/utils/date'
import Hls from 'hls.js'
import {
  computed,
  nextTick,
  onBeforeUnmount,
  onMounted,
  ref,
  watch,
  withDefaults,
} from 'vue'
import { CameraDetail } from '@/@types/typescript-axios'

type displaySizeType = {
  width: number
  height: number
}

type PropsType = {
  cameraDetail: CameraDetail
  displaySize: displaySizeType
  useLive: boolean
  streamArchiveDate: string | null
}


export default /*#__PURE__*/_defineComponent({
  __name: 'MultiVideoStream',
  props: {
    cameraDetail: null,
    displaySize: null,
    useLive: { type: Boolean },
    streamArchiveDate: { default: null }
  },
  emits: ["loadedData", "loadedError"],
  setup(__props: any) {

const props = __props as { cameraDetail: CameraDetail, displaySize: displaySizeType, useLive: boolean, streamArchiveDate: string | null };



const streamLiveVideo = ref<HTMLMediaElement>()
const hls = new Hls()
const loading = ref<boolean>(false)
const streamingUrl = ref<string | null | undefined>(null)



onMounted(async () => {
  getStreamUrl()
})

onBeforeUnmount(() => {
  hls.destroy()
})

const showSpinner = computed<boolean>(() => loading.value || streamingUrl.value === undefined)
const noDataLiveStyle = computed<{ height: string }>(() => {
  return {
    height: `${props.displaySize.height}px`,
  }
})

const getStreamUrl = async () => {
  loading.value = true
  streamingUrl.value = undefined
  let params = {
    mode: 'live',
    expires: APP.STREAMING_EXPIRES_LIVE,
  }
  if (!props.useLive) {
    // TODO UI変更の時(60秒以外の時)にexpiresTimeやend_datetime変更必要
    const streamArchiveDate = getDateObject(getIsoDateStr(props.streamArchiveDate))
    const archiveEndTime = getAddTime(streamArchiveDate, 1, 'minutes')
    params = {
      mode: 'on_demand',
      start_datetime: getIsoDateStr(props.streamArchiveDate),
      end_datetime: getIsoDateStr(archiveEndTime),
      expires: APP.STREAMING_EXPIRES_ARCHIVE,
    }
  }
  const streamingApi: string = API.STREAMING.replace('{cameraCode}', props.cameraDetail.camera_code)
  try {
    const res = await http.post(streamingApi, params)
    if (res.data.result === 'failed') {
      streamingUrl.value = null
      loading.value = false
      return
    }
    streamingUrl.value = res.data.data.url
    nextTick(() => {
      videoPlay()
    })
  } catch (e) {
    // エラーの場合映像の再生の部分に問題があるので初期化する
    streamingUrl.value = null
    loading.value = false
  }
}

const videoPlay = () => {
  if (!streamingUrl.value) {
    return
  }
  if (Hls.isSupported()) {
    hls.loadSource(streamingUrl.value)
    hls.attachMedia(streamLiveVideo.value)
    streamLiveVideo.value.play()
  } else if (streamLiveVideo.value.canPlayType('application/vnd.apple.mpegurl')) {
    streamLiveVideo.value.src = props.cameraDetail.data_url
  }
  loading.value = false
}

watch(
  () => props.streamArchiveDate,
  () => {
    if (!props.useLive) {
      nextTick(() => {
        getStreamUrl()
      })
    }
  }
)

watch(
  () => props.useLive,
  () => {
    getStreamUrl()
  }
)

return (_ctx: any,_cache: any) => {
  return (streamingUrl.value)
    ? (_openBlock(), _createElementBlock("video", {
        key: 0,
        ref_key: "streamLiveVideo",
        ref: streamLiveVideo,
        muted: "",
        playsinline: "",
        onLoadeddata: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('loadedData', $event))),
        onError: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('loadedError')))
      }, null, 544))
    : (_unref(showSpinner))
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_unref(Spinner), {
            class: "spinner",
            size: "60px"
          })
        ]))
      : (__props.cameraDetail.use_nolive)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("span", null, _toDisplayString(_ctx.$t('videos.not_support')), 1)
          ]))
        : (__props.useLive)
          ? (_openBlock(), _createElementBlock("div", {
              key: 3,
              class: "no_data_live",
              style: _normalizeStyle(_unref(noDataLiveStyle))
            }, [
              _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.$t('live.cannot_live')), 1),
              _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.$t('live.please_contact')), 1)
            ], 4))
          : (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createElementVNode("span", null, _toDisplayString(_ctx.$t('videos.no_data')), 1)
            ]))
}
}

})